import { render, staticRenderFns } from "./LightUgTableHeaderRow.vue?vue&type=template&id=e8c76ad8&scoped=true"
import script from "./LightUgTableHeaderRow.vue?vue&type=script&lang=ts"
export * from "./LightUgTableHeaderRow.vue?vue&type=script&lang=ts"
import style0 from "./LightUgTableHeaderRow.vue?vue&type=style&index=0&id=e8c76ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c76ad8",
  null
  
)

export default component.exports